// start:ng42.barrel
export * from './chart-option.model';
// end:ng42.barrel

